<template>
  <v-menu
    v-model="showDatePicker"
    :close-on-content-click="false"
    full-width
    max-width="290"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        prepend-icon="date_range"
        v-on="on"
        :value="displayValue"
        :disabled="disabled"
        v-bind="$attrs"
        @click:clear="setDateFromValue(null)"
        @change="setFormattedDate"
      ></v-text-field>
    </template>

    <v-date-picker
      @input="setDateFromValue"
      :value="formattedValue"
      @change="showDatePicker = false"
      v-bind="$attrs"
    />
  </v-menu>
</template>

<script>
export default {
  name: "datePicker",
  data() {
    return {
      showDatePicker: false,
      rawDate: null
    };
  },
  methods: {
    setDateFromValue(dateString, oldDate) {
      let theDate = null;
      if (this.$moment(dateString).isSame(this.$moment(oldDate))) {
        return;
      }
      if (this.$moment(dateString).isSame("1900-01-01 00:00:00", "second")) {
        this.rawDate = null;
      }
      if (this.$moment(dateString).isValid()) {
        theDate = this.$moment(dateString)
          .startOf("day")
          .toDate();
        console.log("Setting date: ", theDate);
        this.rawDate = theDate;
        this.$emit("input", this.$moment(theDate).format("YYYY-MM-DD"));
      } else {
        this.rawDate = null;
      }
    },
    setFormattedDate(text) {
      console.debug("setting formatted date: ", this.displayValue, text);
      if (this.displayValue != text) {
        this.setDateFromValue(
          this.$moment(text, "DD/MM/YYYY").format("YYYY-MM-DD")
        );
      }
      this.showDatePicker = false;
    }
  },
  computed: {
    formattedValue() {
      if (this.rawDate) {
        return this.$moment(this.rawDate).format("YYYY-MM-DD");
      } else {
        return null;
        return this.$moment().format("YYYY-MM-DD");
      }
    },
    displayValue() {
      return this.rawDate
        ? this.$moment(this.rawDate)
            .calendar()
            .split(" at ")[0]
        : "";
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: "setDateFromValue"
    }
  },
  props: {
    value: [String, Date],
    disabled: Boolean
  }
};
</script>
